import React from "react";
import styles from "../../Style/Subheader.module.css";
import logo from "../../../../Assets/Images/Subheader_logo.svg";
import { useSelector } from "react-redux";
import CustomBadge from "../../../../Assets/components/Avatar/Badge/Badge";

function AddHeaderText({ onLogoClick }) {
  const pendingChats = useSelector((state) => state.Buzzcom.pendingChats);
  const presentScreen = useSelector((state) => state.Buzzcom.presentScreen);
  return (
    <div className={styles.height}>
      <div className={styles.logo}>
        <img
          src={logo}
          alt="logo"
          className={styles.image}
          onClick={onLogoClick}
        />
        <h6 className="msg-name">{presentScreen}</h6>
        {pendingChats > 0 && <CustomBadge pendingChats={pendingChats} />}
      </div>
    </div>
  );
}

export default AddHeaderText;
